(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["historical-period-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('otm-period-grid')) {
    customElements.define('otm-period-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('[data-grid]');
        this.pagination = this.querySelector('[data-source-pagination]');
        this.button = this.querySelector('[data-load-more]');
        this.footer = this.querySelector('[data-footer]');
        this.status = this.querySelector('[data-status]');
        this.showAll = this.dataset.showAll === 'true';
        this.visibleCount = this.showAll ? Infinity : (Number(this.dataset.initialCount) || 24);
        this.alphabet = this.querySelector('[data-alphabet]');
        this.batchSize = Number(this.dataset.loadCount) || 4;
        this.classList.add('is-enhanced');
        this.renderCards();
        this.button.disabled = true;
        this.button.addEventListener('click', () => {
          this.visibleCount += this.batchSize;
          this.renderCards();
        });
        this.alphabet.addEventListener('click', event => {
          const button = event.target.closest('[data-letter]');
          if (!button || button.disabled) return;
          const cards = Array.from(this.grid.querySelectorAll('[data-card]'));
          const index = cards.findIndex(card => this.firstLetter(card) === button.dataset.letter);
          if (index < 0) return;
          if (!this.showAll) this.visibleCount = Math.max(this.visibleCount, index + this.batchSize);
          this.renderCards();
          this.alphabet.querySelectorAll('[data-letter]').forEach(item => item.removeAttribute('aria-current'));
          button.setAttribute('aria-current', 'true');
          cards[index].focus({ preventScroll: true });
          cards[index].scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
        this.loadRemaining();
      }

      firstLetter(card) {
        return (card.dataset.title || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').charAt(0).toUpperCase();
      }

      updateAlphabet() {
        const available = new Set(Array.from(this.grid.querySelectorAll('[data-card]')).map(card => this.firstLetter(card)));
        this.alphabet.querySelectorAll('[data-letter]').forEach(button => { button.disabled = !available.has(button.dataset.letter); });
        this.alphabet.hidden = false;
      }

      renderCards() {
        const cards = Array.from(this.grid.querySelectorAll('[data-card]'));
        cards.forEach((card, index) => { card.hidden = index >= this.visibleCount; });
        this.footer.hidden = cards.length <= this.visibleCount;
        this.querySelector('[data-empty]').hidden = cards.length > 0;
        this.status.textContent = `${Math.min(this.visibleCount, cards.length)} of ${cards.length} styles shown.`;
      }

      async loadRemaining() {
        let next = this.pagination.dataset.nextUrl;
        const seen = new Set(Array.from(this.grid.querySelectorAll('[data-card]')).map(card => card.dataset.handle));
        const visited = new Set();
        try {
          while (next) {
            const url = new URL(next, window.location.href);
            if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid pagination');
            visited.add(url.href);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
            if (!response.ok) throw new Error('Section request failed');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const section = html.getElementById(this.id);
            if (!section) throw new Error('Section not found');
            section.querySelectorAll('[data-card]').forEach(card => {
              if (!seen.has(card.dataset.handle)) {
                seen.add(card.dataset.handle);
                card.hidden = true;
                this.grid.appendChild(document.importNode(card, true));
              }
            });
            next = section.querySelector('[data-source-pagination]')?.dataset.nextUrl || '';
          }
          const collator = new Intl.Collator(document.documentElement.lang || 'en', { sensitivity: 'base', numeric: true });
          Array.from(this.grid.querySelectorAll('[data-card]'))
            .sort((a, b) => collator.compare(a.dataset.title, b.dataset.title))
            .forEach(card => this.grid.appendChild(card));
          this.renderCards();
        } catch (error) {
          this.classList.add('has-load-error');
        } finally {
          this.updateAlphabet();
          this.renderCards();
          this.button.disabled = false;
          const count = this.grid.querySelectorAll('[data-card]').length;
          this.status.textContent = `${Math.min(this.visibleCount, count)} of ${count} styles shown.`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-otm-premium"]) return;
  try {
    
  if (!customElements.get('otm-product-editorial')) {
    customElements.define('otm-product-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const mobile = window.matchMedia('(max-width: 749px)');
        const cards = [...this.querySelectorAll('.otm-four-card')];
        const sync = () => cards.forEach(card => {
          card.open = !mobile.matches;
          const summary = card.querySelector('summary');
          if (mobile.matches) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
        cards.forEach(card => card.querySelector('summary').addEventListener('click', event => {
          if (!mobile.matches) { event.preventDefault(); return; }
          if (!card.open) cards.forEach(other => { if (other !== card) other.open = false; });
        }, options));
        mobile.addEventListener('change', sync, options);
        sync();
        this.querySelectorAll('[data-otm-policy-open]').forEach(link => {
          link.addEventListener('click', event => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const dialog = this.querySelector('[data-otm-policy-dialog="' + link.dataset.otmPolicyOpen + '"]');
            if (!dialog || typeof dialog.showModal !== 'function') return;
            event.preventDefault();
            if (!dialog.open) dialog.showModal();
          }, options);
        });
        this.querySelectorAll('[data-otm-policy-dialog]').forEach(dialog => {
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, options);
          dialog.addEventListener('close', () => { dialog.scrollTop = 0; }, options);
        });
      }
      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["otm-print-editorial-dynamic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('otm-review-slider')) {
  customElements.define('otm-review-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      const viewport = this.querySelector('.otm-reviews__viewport');
      const track = this.querySelector('.otm-reviews__track');
      const group = this.querySelector('.otm-reviews__group');
      const button = this.closest('.otm-reviews').querySelector('[data-review-pause]');
      const mobile = matchMedia('(max-width: 749px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const clone = group.cloneNode(true);
      clone.dataset.clone = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.removeAttribute('role');
      clone.querySelectorAll('*').forEach(el => {
        el.removeAttribute('data-shopify-editor-block');
        el.removeAttribute('id');
        el.removeAttribute('role');
      });
      track.append(clone);
      let position = 0;
      let userPaused = false, interacting = false, focused = false, visible = true, resumeAt = 0, last = 0;
      const editor = Boolean(window.Shopify && Shopify.designMode);
      const canLoop = group.children.length > 1;
      const update = () => {
        button.hidden = !mobile.matches || reduced.matches || editor || !canLoop;
        clone.hidden = reduced.matches || !canLoop;
        if (!mobile.matches) viewport.scrollLeft = 0;
      };
      button.addEventListener('click', () => {
        userPaused = !userPaused;
        button.setAttribute('aria-pressed', String(userPaused));
        button.querySelector('[data-pause-label]').hidden = userPaused;
        button.querySelector('[data-play-label]').hidden = !userPaused;
      }, opts);
      viewport.addEventListener('pointerdown', () => { interacting = true; }, opts);
      const release = () => { interacting = false; resumeAt = performance.now() + 3000; };
      window.addEventListener('pointerup', release, opts);
      window.addEventListener('pointercancel', release, opts);
      viewport.addEventListener('focusin', () => { focused = true; }, opts);
      viewport.addEventListener('focusout', () => { focused = false; resumeAt = performance.now() + 3000; }, opts);
      viewport.addEventListener('wheel', () => { resumeAt = performance.now() + 3000; }, { ...opts, passive: true });
      mobile.addEventListener('change', update, opts);
      reduced.addEventListener('change', update, opts);
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
      this.observer.observe(this);
      const tick = now => {
        const elapsed = last ? Math.min(now - last, 50) : 0;
        last = now;
        if (canLoop && mobile.matches && !reduced.matches && !userPaused && !interacting && !focused && visible && !document.hidden && now > resumeAt) {
          const distance = clone.offsetLeft - group.offsetLeft;
          if (distance > 0) {
            if (Math.abs(viewport.scrollLeft - position) > 2) position = viewport.scrollLeft;
            const next = position + elapsed * (Number(this.dataset.speed) || 24) / 1000;
            position = next >= distance ? next - distance : next;
            viewport.scrollLeft = position;
          }
        }
        this.frame = requestAnimationFrame(tick);
      };
      update();
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      this.abort.abort();
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
      this.querySelector('[data-clone]')?.remove();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
